import React from "react";
import classNames from "classnames";
import style from "./LinkButton.css";

const LinkButton = ({ className = undefined, ...rest }) => (
    <button className={classNames(style.main, className)} {...rest} />
);

export default LinkButton;
